<script setup lang="ts">
import { useRoute, useRouter } from "vue-router";
import { ref, onMounted } from "vue";
import RvApi, { type Device } from "@/rvapi";
import DeviceDetails from "@/components/DeviceDetails.vue";
import UserLookup from "@/components/UserLookup.vue";

const route = useRoute();
const router = useRouter();
const deviceId = route.params.id as string;
const device = ref(undefined as Device | undefined);
const error = ref("");
const loaded = ref(false);
onMounted(async () => {
  const result = await RvApi.searchDevices(deviceId);
  if (result.length !== 1) {
    error.value = "Invalid legacy device";
    loaded.value = true;
    return;
  }
  device.value = result.find(() => true);
  loaded.value = true;
});
const migrate = async (userId: string) => {
  loaded.value = false;
  const result = await RvApi.migrateBalanceToUser(userId, deviceId, false);
  if (result.balance) {
    router.push(`/user/${userId}`);
  } else {
    error.value = "Did not migrate balance properly.";
    loaded.value = true;
  }
};
</script>

<template>
  <h1>Migrate legacy balance to user</h1>
  <pn-toast
    appearance="error"
    closable="false"
    v-show="error"
    :text="error"
  ></pn-toast>
  <pn-spinner size="4" v-show="!loaded" />
  <section v-show="!!loaded && device">
    <h3>From device</h3>
    <DeviceDetails :device="device" :simple="true" />
    <pn-toast
      v-show="!device?.legacyBalance"
      closable="false"
      text="Device has no balance!"
    ></pn-toast>
    <UserLookup v-if="device?.legacyBalance" @userSelected="migrate" />
  </section>
</template>
